
import { get, set, del } from 'idb-keyval';
import Store from '@/store';
import Device from '@/wrappers/Device';
import { Preferences } from '@capacitor/preferences';
import ErrorReporter from '@/wrappers/ErrorReporter';

const AppStorage = {

    local() {
        return {
            defaultPrefix() {
                return Store.getters.tenant?.venue?.hash || ''
            },

            getItem(key, prefix = this.defaultPrefix()) {
                if(prefix) {
                    key = prefix + '-' + key
                }
                return localStorage.getItem(key)
            },

            setItem(key, value, prefix = this.defaultPrefix()) {
                if(prefix) {
                    key = prefix + '-' + key
                }

                localStorage.setItem(key, value)
            },

            deleteItem(key, prefix = this.defaultPrefix()) {
                if(prefix) {
                    key = prefix + '-' + key
                }

                localStorage.removeItem(key)
            }
        }
    },

    store() {
        return {
            async getItem(key) {
                const value = await get(key)
                if(value === undefined) return null
                return value
            },

            setItem(key, value) {
                set(key, value).catch(error => {
                    if (error.name === 'QuotaExceededError') {
                        ErrorReporter.reportMessage('Error setting item in IndexedDB: QuotaExceededError')
                        console.error('Not enough memory available for IndexedDB', error);
                    } else {
                        ErrorReporter.reportMessage('Error setting item in IndexedDB: ' + error.name)
                        console.error('Error setting item in IndexedDB:', error);
                    }
                })
            },

            deleteItem(key) {
                del(key)
            }
        }
    },

    native() {
        return {
            defaultPrefix() {
                return Store.getters.tenant?.venue?.hash || ''
            },

            async getItem(key, prefix = this.defaultPrefix()) {
                const device = Device.get();

                if(prefix) {
                    key = prefix + '-' + key
                }

                if (device.platform === 'electron') {
                    const value = window.electron.store ? window.electron.store.get(key) : null
                    if(value === undefined) return null
                    return value
                }

                if (device.platform === 'android') {
                    const { value } = await Preferences.get({ key });
                    if(value === undefined) return null
                    return value;
                }

                return localStorage.getItem(key)
            },

            setItem(key, value, prefix = this.defaultPrefix()) {
                const device = Device.get();

                if(prefix) {
                    key = prefix + '-' + key
                }

                if (device.platform === 'electron') {
                    if(window.electron.store) {
                        window.electron.store.set(key, value)
                    }
                } else if (device.platform === 'android') {
                    if (!(typeof value === 'string' || value instanceof String)) {
                        value = JSON.stringify(value)
                    }
                    Preferences.set({ key, value });
                } else {
                    localStorage.setItem(key, value)
                }
            },

            deleteItem(key, prefix = this.defaultPrefix()) {
                const device = Device.get();

                if(prefix) {
                    key = prefix + '-' + key
                }

                if (device.platform === 'electron') {
                    if(window.electron.store) {
                        window.electron.store.delete(key)
                    }
                } else if (device.platform === 'android') {
                    Preferences.remove({ key });
                } else {
                    localStorage.removeItem(key)
                }
            }
        }
    },
};

export default AppStorage;

export { AppStorage };
